import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { type AboutUsData, aboutUsData } from './aboutUsData'

export function useAboutUsData(): AboutUsData {
  const { market } = useMarketplace()

  return aboutUsData[market.countryCode]
}
